// pages/Profile.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

const Profile = () => {
  const { user, token } = useSelector((state) => state.user);

  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    if (!token) return;

    const fetchBookings = async () => {
      try {
        const response = await axios.get(
          'http://localhost:8000/api/bookings/',
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setBookings(response.data);
      } catch (err) {
        console.error('Ошибка:', err);
      }
    };

    fetchBookings();
  }, [token]);

  if (!user || !token) {
    return <p>Вы не авторизованы.</p>;
  }

  return (
    <div className="profile">
      <h1>Личный кабинет</h1>
      <div className="user-info">
        <p>Имя пользователя: {user.username}</p>
        <p>Email: {user.email}</p>
      </div>

      <h2>Ваши бронирования</h2>
      {bookings.length === 0 ? (
        <p>У вас нет активных бронирований.</p>
      ) : (
        <ul>
          {bookings.map(booking => (
            <li key={booking.id}>
              <p>Автомобиль: {booking.car?.brand}</p>
              <p>Дата: {booking.start_date}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Profile;